var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.394,285.996c1.643-1.643,1.643-4.314,0-5.958l-1.086-1.086c-1.643-1.643-4.314-1.643-5.956,0 l-8.247,8.232l7.058,7.05L165.394,285.996z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.249,308.328l8.246-8.232c1.644-1.651,1.644-4.314,0-5.957l-1.1-1.101c-1.643-1.643-4.314-1.643-5.957,0 l-8.232,8.247L171.249,308.328z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.581,308.225l-1.086-1.086c-1.643-1.644-4.314-1.644-5.957,0l-8.246,8.232l7.058,7.05l8.232-8.238 C195.224,312.539,195.224,309.868,193.581,308.225z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.667,328.276c1.658-1.643,1.658-4.306,0.015-5.95l-1.1-1.1c-1.643-1.644-4.314-1.644-5.958,0l-8.232,8.246 l7.043,7.043L207.667,328.276z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.035,341.255l-8.231,8.239c-1.644,1.643-1.644,4.306,0,5.949l1.1,1.101c1.644,1.644,4.3,1.644,5.958,0 l8.232-8.232L96.035,341.255z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.135,355.355l-8.232,8.231c-1.643,1.644-1.643,4.315,0,5.958l1.086,1.086c1.644,1.644,4.314,1.644,5.958,0 l8.232-8.232L110.135,355.355z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.221,369.441l-8.231,8.239c-1.643,1.644-1.643,4.307,0,5.95l1.085,1.101c1.658,1.643,4.315,1.643,5.958,0 l8.247-8.239L124.221,369.441z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.322,383.535l-8.232,8.239c-1.644,1.643-1.644,4.314-0.015,5.95l1.1,1.093 c1.643,1.643,4.314,1.643,5.958,0l8.232-8.232L138.322,383.535z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.667,335.319c-1.629-1.635-4.3-1.635-5.942,0.008l-8.247,8.232l7.043,7.043l8.247-8.232 c1.643-1.643,1.643-4.306,0-5.958L220.667,335.319z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.992,
    y: 313.927,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 19.6226 699.9984)",
    className: "st0",
    width: 119.587,
    height: 64.016
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.177,405.867c-1.644,1.643-1.644,4.306,0,5.95l1.086,1.093c1.658,1.65,4.314,1.643,5.957,0l8.232-8.239 l-7.043-7.043L144.177,405.867z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.974,190.43c1.644-1.65,1.644-4.314,0-5.957l-1.1-1.1c-1.644-1.644-4.314-1.644-5.958,0l-8.232,8.246 l7.043,7.043L260.974,190.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.828,212.755l8.232-8.239c1.644-1.643,1.644-4.314,0-5.957l-1.086-1.086c-1.643-1.643-4.314-1.643-5.958,0 l-8.246,8.232L266.828,212.755z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.161,212.653l-1.1-1.093c-1.643-1.643-4.314-1.643-5.958,0l-8.232,8.246l7.043,7.043l8.246-8.239 C290.804,216.966,290.804,214.303,289.161,212.653z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303.247,232.704c1.643-1.644,1.643-4.315,0-5.958l-1.101-1.093c-1.643-1.636-4.3-1.636-5.942,0.008 l-8.246,8.232l7.058,7.043L303.247,232.704z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.468,260.964c1.644,1.643,4.315,1.643,5.958,0l8.232-8.232l-7.043-7.043l-8.232,8.232 c-1.643,1.643-1.658,4.314,0,5.957L184.468,260.964z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.469,268.014c-1.643,1.643-1.643,4.306,0,5.949l1.1,1.101c1.643,1.644,4.3,1.644,5.942,0l8.247-8.239 l-7.058-7.05L197.469,268.014z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.57,288.065l1.086,1.086c1.643,1.644,4.314,1.644,5.958,0l8.232-8.232l-7.043-7.043l-8.232,8.232 C209.926,283.751,209.926,286.421,211.57,288.065z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.888,287.962l-8.232,8.232c-1.644,1.651-1.644,4.314,0,5.957l1.1,1.101c1.644,1.643,4.3,1.643,5.943-0.008 l8.246-8.232L233.888,287.962z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M316.248,239.747c-1.644-1.644-4.314-1.644-5.958,0l-8.232,8.246l7.043,7.043l8.232-8.239 c1.643-1.651,1.658-4.306,0-5.957L316.248,239.747z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "185.452,230.715 269.998,315.269 315.264,270.002 230.703,185.449  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.757,310.294c-1.643,1.643-1.643,4.314-0.014,5.95l1.1,1.093c1.644,1.65,4.314,1.643,5.957,0l8.232-8.232 l-7.043-7.05L239.757,310.294z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.539,94.85c1.644-1.643,1.644-4.314,0-5.957l-1.086-1.086c-1.643-1.643-4.314-1.643-5.958,0l-8.246,8.232 l7.058,7.05L356.539,94.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.394,117.183l8.246-8.239c1.643-1.643,1.643-4.306,0-5.95l-1.1-1.1c-1.643-1.643-4.314-1.643-5.958,0 l-8.232,8.246L362.394,117.183z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.495,131.276l8.232-8.239c1.643-1.643,1.643-4.314,0-5.957l-1.086-1.086c-1.644-1.643-4.314-1.643-5.958,0 l-8.246,8.232L376.495,131.276z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M390.581,145.37l8.232-8.239c1.643-1.644,1.658-4.307,0.014-5.95l-1.1-1.1c-1.644-1.643-4.314-1.643-5.958,0 l-8.232,8.239L390.581,145.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.049,165.398c1.643,1.643,4.3,1.643,5.958,0l8.232-8.239l-7.058-7.051l-8.232,8.232 c-1.643,1.65-1.643,4.314,0,5.958L280.049,165.398z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.281,164.21l-8.232,8.232c-1.644,1.643-1.644,4.314,0,5.957l1.086,1.086c1.643,1.643,4.314,1.643,5.957,0 l8.232-8.232L301.281,164.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.367,178.296l-8.232,8.238c-1.644,1.644-1.644,4.307,0,5.95l1.1,1.093c1.643,1.651,4.299,1.651,5.942,0 l8.246-8.232L315.367,178.296z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.468,192.389l-8.232,8.239c-1.658,1.644-1.658,4.314-0.014,5.95l1.101,1.093 c1.643,1.644,4.314,1.644,5.956,0l8.232-8.232L329.468,192.389z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.813,144.174c-1.629-1.636-4.299-1.636-5.943,0.008l-8.246,8.232l7.057,7.043l8.232-8.232 c1.644-1.644,1.644-4.314,0-5.957L411.813,144.174z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.137,
    y: 122.781,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 481.0893 508.8518)",
    className: "st0",
    width: 119.587,
    height: 64.016
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.322,214.721c-1.643,1.644-1.643,4.306,0,5.95l1.086,1.093c1.658,1.65,4.314,1.644,5.957,0l8.232-8.239 l-7.043-7.043L335.322,214.721z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472.31,117.322c-8.1,8.1-21.232,8.092-29.332,0c-8.099-8.1-8.099-21.224,0-29.331l-27.307-27.307 c-8.099,8.099-21.231,8.092-29.331,0c-8.099-8.099-8.099-21.224,0-29.332L354.984,0.003L0,354.981l31.356,31.349 c8.099-8.092,21.232-8.092,29.332,0c8.099,8.107,8.099,21.239,0,29.332l27.306,27.306c8.1-8.092,21.232-8.092,29.331,0 c8.1,8.107,8.1,21.24,0,29.331l39.69,39.698L512,157.013L472.31,117.322z M469.595,184.239l-13.675,13.682l-14.894-14.9 l-8.965,8.965l14.893,14.894l-13.675,13.682l-14.893-14.9l-8.966,8.966l14.893,14.893l-13.675,13.675l-14.893-14.893l-8.965,8.958 l14.894,14.9l-13.676,13.675l-14.893-14.893l-8.965,8.958l14.893,14.9l-13.675,13.675l-14.894-14.893l-8.965,8.957l14.893,14.9 l-13.675,13.676l-14.893-14.894l-8.966,8.95l14.893,14.908l-13.675,13.675l-14.893-14.893l-8.965,8.958l14.894,14.9l-13.675,13.675 l-14.894-14.893l-8.965,8.958l14.893,14.9l-13.675,13.675l-14.893-14.9l-8.966,8.958l14.908,14.907l-13.69,13.675l-14.893-14.893 l-8.966,8.95l14.908,14.908l-13.69,13.675l-14.893-14.893l-8.965,8.958l14.893,14.901l-13.675,13.675l-14.894-14.901l-8.965,8.958 l14.908,14.901l-13.69,13.682l-14.893-14.9l-8.966,8.957l14.908,14.9l-18.268,18.268l-25.854-25.846 c5.429-11.658,3.346-25.986-6.25-35.59c-9.611-9.603-23.932-11.686-35.582-6.258l-14.805-14.79 c5.429-11.658,3.346-25.986-6.251-35.589c-9.611-9.604-23.931-11.688-35.582-6.258l-17.52-17.513L354.984,15.176l17.519,17.505 c-5.444,11.65-3.36,25.985,6.251,35.582c9.596,9.611,23.932,11.694,35.582,6.258l14.805,14.797 c-5.444,11.666-3.36,25.986,6.25,35.582c9.596,9.611,23.932,11.695,35.582,6.259l25.854,25.854l-18.268,18.268l-14.893-14.901 l-8.966,8.966L469.595,184.239z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemory);
export default __webpack_public_path__ + "static/media/memory.f5b870968b2b919674cbd10e66f44e46.svg";
export { ForwardRef as ReactComponent };